import * as React from 'react';

import { Message as AIMessage } from '@ai-sdk/react';

import { ToolInvocation, ToolName } from '../types';

import { ToolStatus } from './ToolStatus';

export interface ToolCallProps {
  toolInvocation: ToolInvocation;
  message: AIMessage;
  openContent?: (result?: string | Record<string, unknown>) => void;
}

const TOOL_TEXT_DICT = {
  retrieve_current_draft_study_from_scratchpad: {
    doneText: 'Draft study retrieved',
    executingText: 'Retrieving draft study...'
  },
  save_draft_study_to_scratchpad: {
    doneText: 'Draft study saved',
    executingText: 'Saving draft study...'
  },
  clear_draft_study_from_scratchpad: {
    doneText: 'Draft study cleared',
    executingText: 'Clearing draft study...'
  },
  recommend_study_type_based_on_research_context: {
    doneText: 'Study type recommended',
    executingText: 'Recommending study type...'
  },
  greatquestion_create_unmoderated_study_tool: {
    doneText: 'Survey created',
    executingText: 'Creating survey...'
  },
  greatquestion_create_moderated_study_tool: {
    doneText: 'Interview study created',
    executingText: 'Creating interview study...'
  },
  'multi_tool_use.parallel': {
    doneText: 'Tools executed',
    executingText: 'Executing tools...'
  },
  unknown: {
    doneText: 'Work completed',
    executingText: 'Working...'
  }
} as const;

export const DefaultToolCall: React.FC<ToolCallProps> = ({ toolInvocation }) => {
  const toolText = TOOL_TEXT_DICT[toolInvocation.toolName] || TOOL_TEXT_DICT.unknown;

  return (
    <div className='mt-2'>
      <ToolStatus state={toolInvocation.state} doneText={toolText.doneText} executingText={toolText.executingText} />
    </div>
  );
};
